import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { useT } from "@/lib/translation";
import { getUserSettings, updateUserSettings } from "@/api/client";

export function useUserSettings(enabled: boolean) {
  const queryClient = useQueryClient();
  const t = useT();

  const settingsQuery = useQuery({
    queryKey: ["userSettings"],
    queryFn: getUserSettings,
    enabled,
  });

  const updateSettingsMutation = useMutation({
    mutationFn: updateUserSettings,
    onSuccess: () => {
      toast.success(t("settings:toast.success"), {
        description: t("settings:toast.saved"),
      });
      queryClient
        .invalidateQueries({ queryKey: ["userSettings"] })
        .catch(() => {});
    },
    onError: (e: Error) => {
      toast.error(t("settings:toast.error"), {
        description: e.message || t("settings:toast.saveFailed"),
      });
    },
  });

  return {
    userSettings: settingsQuery.data,
    isLoading: settingsQuery.isLoading,
    isError: settingsQuery.isError,
    updateSettings: updateSettingsMutation.mutate,
    isUpdating: updateSettingsMutation.isPending,
  };
}
